import { Pipe, PipeTransform } from '@angular/core';
import { ETemplateText } from '../../config/ETemplateText';

@Pipe({
  name: 'templateText'
})
export class TemplateTextPipe implements PipeTransform {
  public word: string = '';
  public templateText: any = ETemplateText;
  public transform(value: string): any {
    (this.templateText[CONFIG.SessionName][value])
      ? this.word = this.templateText[CONFIG.SessionName][value]
      : this.word = value;
    return this.word;
  };
}
